import type { Step as ProseMirrorStep } from '@atlaskit/editor-prosemirror/transform';

export class InvertableStep {
	constructor(
		readonly step: ProseMirrorStep,
		readonly inverted: ProseMirrorStep,
	) {}
}
